import React, { useEffect, useState } from "react";
import { Modal } from '@mantine/core';
import axios from "axios";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { IconButton, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useDisclosure } from "@mantine/hooks";

const DocuSignModal = ({
  isOpen,
  onRequestClose,
  signUrl,
  handleIframeClose,
}) => {
  const [backdropopen, setbackdropopen] = useState(false);

  const handleLoad = () => {
    setbackdropopen(false);
  };

  const handleClose = () => {
    handleIframeClose();
    onRequestClose();
  };

  // useEffect(() => {
  //   if (signUrl) {
  //     setbackdropopen(true);
  //   }
  // }, []);

   const [opened, { open, close }] = useDisclosure(false);

  return (
    <>
      <Backdrop sx={{ color: "#fff", zIndex: "3000" }} open={backdropopen}>
        <CircularProgress color="inherit" />
      </Backdrop>
      
      <Modal
        opened={isOpen}
        onClose={onRequestClose}
        fullScreen
        withCloseButton={false}
        transitionProps={{ transition: "slide-up" }}
        padding={0}

        
      >
         <div className="d-flex justify-content-end" style={{height:"60px"}}>
          <Button
            variant="contained"
            color="error"
            onClick={handleClose}
            style={{ margin: "10px 20px" }}
          >
            Close
          </Button>
        </div>
        {/* <div className="d-flex justify-content-end">
          <Button
            variant="contained"
            color="secondary"
            onClick={handleClose}
            style={{ marginBottom: "10px" }}
          >
            Close
          </Button>
        </div> */}
        {signUrl ? (
          <iframe
            src={signUrl}
            title="DocuSign"
            width="100%"
            height="90%"
            onLoad={handleLoad}
            style={{ border: "none" }}
          ></iframe>
        ) : (
          <p>Loading...</p>
        )}
       
      </Modal>
    </>
  );
};

export default DocuSignModal;
